<template>
<b-row>
    <b-col md="12" class="text-center">
    <b-form-group label-for="selectFleet" label="Select Fleet">
        <b-row>
        <b-col md="2" v-for="(each, i) in fleetList" :key="i">
            <label>
                <input type="radio" name="fleet" :value="each.id" v-model="vehicleTypeIdSelected" @change="handleChangeSelectFleet($event)">
                <img :src="each.vehicleType && each.vehicleType.icon ? each.vehicleType.icon.url : require('../../../../assets/images/fleet/ahts.png')" height="80px" width="auto">
            </label>
            <p>{{ each.name }}</p>
        </b-col>
        </b-row>
    </b-form-group>
    </b-col>
    <b-col md="12">
    <fieldset class="form-group border p-3">
        <legend class="w-auto px-2">GENERAL INFORMATION</legend>
        <b-row>
        <b-col md="6">
            <b-form-group label-for="reportDate" label="Report Date">
            <b-form-input id="exampleInputmonth" type="date" v-model="formActivites.date" ></b-form-input>
            <small style="float: right">click <i class="fa fa-calendar"></i> to show</small>
            </b-form-group>
        </b-col>
        <b-form-group class="col-md-3" label="Latitude" label-for="id_gps" >
            <b-form-input type="number" v-model="formActivites.lat"></b-form-input>
        </b-form-group>
        <b-form-group class="col-md-3" label="Longitude" label-for="id_gps" >
            <b-form-input type="number" v-model="formActivites.lon"></b-form-input>
        </b-form-group>
        <b-form-group class="col-md-6" label="Current Location" label-for="id_gps">
            <v-select v-model="formActivites.portId" label="text" :options="positionList" :reduce="positionList => positionList.value" placeholder="Select Position"></v-select>
        </b-form-group>
        <b-form-group class="col-md-6" label="Chartered" label-for="chartered">
        <v-multiselect v-model="formActivites.subProjectId" :options="charteredOptions"
         group-values="sub" group-label="project" placeholder="Select Chartered" track-by="name" label="name"></v-multiselect>
        </b-form-group>

        </b-row>
    </fieldset>
    </b-col>
    <b-col md="12">
    <fieldset class="form-group border p-3">
        <legend class="w-auto px-2">Weather Condition</legend>
        <b-row>
        <b-col md="12" v-if="formActivites.weathers.length > 0">
            <table class="table table-striped">
            <thead>
            <tr>
            <th width="40%" colspan="2" class="text-center">Weather / Time</th>
            <th width="25%" rowspan="2" class="text-center" style="vertical-align: middle">Wind (Dir/Speed)</th>
            <th width="25%" rowspan="2" class="text-center" style="vertical-align: middle">Visibility</th>
            <th width="10%" rowspan="2" class="text-center" style="vertical-align: middle">#</th>
            </tr>
            <tr>
            <th>From</th>
            <th>To</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(weather, index) in formActivites.weathers" :key="index">
            <td>
                <b-form-input id="timeStart" v-model="index === 0 ? weather.timeFrom : weather.timeFrom = formActivites.weathers[index-1].timeEnd" type="time" ></b-form-input>
                <small style="float: right">click <i class="fa fa-clock"></i> to show</small>
            </td>
            <td>
                <b-form-input id="timeEnd" v-model="weather.timeEnd" type="time"></b-form-input>
                <small style="float: right">click <i class="fa fa-clock"></i> to show</small>
            </td>
            <td>
                <b-input-group size="md" append="Knots">
                <b-form-select v-model="weather.wind" label="text" :options="windOptions" placeholder="Select Wind (Dir/Speed)"></b-form-select>
                </b-input-group>
            </td>
            <td class="text-center">
                <b-input-group size="md" append="Nm">
                <b-form-spinbutton class="bg-secondary text-white mr-2" v-model="weather.visibility" min="1" max="10" inline></b-form-spinbutton>
                </b-input-group>
            </td>
            <td >
                <b-button v-if="formActivites.weathers.length > 1" @click.prevent="removeWeatherCondition(index)" size="sm" variant="danger" class="mb-3 mr-1"><i class="fa fa-trash"></i></b-button>
            </td>
            </tr>
            </tbody>
        </table>
        </b-col>
        <b-col md="12" class="text-right">
            <b-button variant="warning" block class="mb-3 mr-1" @click.prevent="addWeatherCondition()"><i class="fa fa-plus"></i> Add Weather Condition</b-button>
        </b-col>
        </b-row>
    </fieldset>
    </b-col>
    <b-col md="12">
    <fieldset class="form-group border p-3">
        <legend class="w-auto px-2">DAILY LOG ACTIVITIES / VESSEL MOVEMENTS</legend>
        <b-row>
        <b-col md="12" v-if="formActivites.logs.length > 0">
            <table class="table table-striped table-warning">
            <thead>
            <tr>
                <th width="15%">Time Start</th>
                <th width="15%">Time End</th>
                <th width="30%">Daily Operational Activities</th>
                <th width="30%">Remarks</th>
                <th width="10%">#</th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="(activities, index) in formActivites.logs" :key="index">
                <td>
                    <b-form-input id="timeStart" v-model="activities.timeFrom = formActivites.weathers[index].timeFrom" type="time" :disabled="true"></b-form-input>
                    <small style="float: right">click <i class="fa fa-clock"></i> to show</small>
                </td>
                <td>
                    <b-form-input id="timeEnd" v-model="activities.timeEnd = formActivites.weathers[index].timeEnd" type="time" :disabled="true"></b-form-input>
                    <small style="float: right">click <i class="fa fa-clock"></i> to show</small>
                </td>
                <td>
                    <v-select v-model="activities.reasonId" :disabled="formDailyActivitiesLoading._saving" label="text" :options="reasonList" placeholder="Select Daily Operational Activities"></v-select>
                </td>
                <td>
                    <b-form-textarea id="remarks" rows="1" v-model="activities.remarks"></b-form-textarea>
                </td>
                <td>
                    <!-- <b-button @click.prevent="removeActivitiesLoading(index)" size="sm" variant="danger" class="mb-3 mr-1"><i class="fa fa-trash"></i></b-button> -->
                </td>
                </tr>
            </tbody>
            </table>
        </b-col>
        <!-- <b-col md="12" class="text-right">
            <b-button variant="warning" block class="mb-3 mr-1" @click.prevent="addActivitiesLoading()"><i class="fa fa-plus"></i> Add Daily Log Activities</b-button>
        </b-col> -->
        </b-row>
    </fieldset>
    </b-col>
    <b-col md="12">
    <fieldset class="form-group border p-3">
        <legend class="w-auto px-2">Running Hours</legend>
        <table class="table table-striped table-info">
        <thead>
        <tr>
            <th width="25%">Type of Machine</th>
            <th width="25%">Running Hours Day</th>
            <th width="25%">Total Running Hours</th>
        </tr>
        </thead>
        <tbody v-if="fleetDetail">
            <template v-if="fleetDetail.powers && fleetDetail.powers.length > 0 && formActivites.runningHours.length > 0">
                <tr v-for="(each, i) in fleetDetail.powers" :key="i">
                    <td>{{each.powerType.name}}</td>
                    <td>
                    <b-input-group size="md" append="Hours">
                        <b-form-input type="text" @input="someHandler" onkeypress="return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)" maxlength="2" v-model="formActivites.runningHours[i].hoursRunningToday"></b-form-input>
                    </b-input-group>
                    <small>Today Running Hours Max 24 Hours</small>
                    </td>
                    <td>
                    <b-input-group size="md" append="Hours">
                        <b-form-input type="number" v-model="formActivites.runningHours[i].hoursRunningActual"></b-form-input>
                    </b-input-group>
                    <small>Total Actual Until Today</small>
                    </td>
                </tr>
            </template>
            <tr v-else >
                <td class="text-center" colspan="8">
                edit vehicle "{{fleetDetail.name}}" and update power!</td>
            </tr>
        </tbody>
        <tbody v-if="!fleetDetail && vehicleTypeIdSelected === null">
            <tr>
                <td class="text-center" colspan="8">Select vehicle first!</td>
            </tr>
        </tbody>
        </table>
    </fieldset>
    </b-col>
    <b-col md="12">
    <fieldset class="form-group border p-3">
        <legend class="w-auto px-2">SUMMARY OF DAILY FUEL, WATER, & CARGOS REMAINING ONBOARD</legend>
        <table class="table table-striped table-primary">
        <thead>
        <tr>
            <th width="15%">Type</th>
            <th width="15%">Opening (ROB From Previous Day)</th>
            <th width="15%">Consumption (Based on Actual Sounding)</th>
            <th width="10%">Transferred</th>
            <th width="10%">Received</th>
            <th width="15%">Closing</th>
            <th width="20%">Remarks</th>
        </tr>
        </thead>
        <tbody v-if="fleetDetail">
        <template v-if="fleetDetail.robs && fleetDetail.robs.length > 0 && formActivites.robs.length > 0">
            <tr v-for="(each, i) in fleetDetail.robs" :key="i"> 
                <td><h6>{{each.robType.name}}</h6></td>
                <td>
                    <!-- <small>August 9, 2021</small> -->
                    <p>{{ each.actualRob }} Ltrs</p>
                </td>
                <td>
                <b-form-input type="number" placeholder="consumption" v-model="formActivites.robs[i].consumption"></b-form-input>
                </td>
                <td><b-form-input type="number" placeholder="transferred" v-model="formActivites.robs[i].transferred"></b-form-input></td>
                <td><b-form-input type="number" placeholder="received" v-model="formActivites.robs[i].received"></b-form-input></td>
                <td><strong>{{ totalCLosing(each.actualRob, formActivites.robs[i].consumption, formActivites.robs[i].transferred, formActivites.robs[i].received) }}Ltrs</strong></td>
                <td><b-form-textarea id="remarks" rows="1" v-model="formActivites.robs[i].remarks"></b-form-textarea></td>
            </tr>
        </template>
        <tr v-else >
            <td class="text-center" colspan="8">
            edit vehicle "{{fleetDetail.name}}" and update ROB!</td>
        </tr>
        </tbody>
        <tbody v-if="!fleetDetail && vehicleTypeIdSelected === null">
            <tr>
                <td class="text-center" colspan="8">Select vehicle first!</td>
            </tr>
        </tbody>
        </table>
    </fieldset>
    </b-col>
    <!-- <b-col md="12">
    <fieldset class="form-group border p-3">
        <legend class="w-auto px-2">CONSUMABLE GOODS</legend>
        <table class="table table-striped table-warning">
        <thead>
        <tr>
            <th width="30%">Goods</th>
            <th width="20%">Last Stock</th>
            <th width="20%">Used</th>
            <th width="30%">Current Stock</th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td><h6>Oxygen</h6></td>
            <td><small>August 9, 2021</small><p>17 Pcs</p></td>
            <td><b-form-input type="number" placeholder="used"></b-form-input></td>
            <td><h6>17 Pcs</h6></td>
        </tr>
        </tbody>
        </table>
    </fieldset>
    </b-col>-->
    <b-col md="12">
    <fieldset class="form-group border p-3">
        <legend class="w-auto px-2">CREW & PASSENGER LIST</legend>
        <b-row>
        <b-col md="6">
            <h5>Crew List</h5>
            <b-row>
            <b-col md="12" v-if="formActivites.crews.length > 0">
                <table class="table table-striped table-success">
                <thead>
                <tr>
                    <th width="15%">No</th>
                    <th width="40%">Name</th>
                    <th width="40%">Position</th>
                    <th width="5%">#</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(crew, index) in formActivites.crews" :key="index">
                    <td>{{index+1}}</td>
                    <td><b-form-input type="text" v-model="crew.name" placeholder="name"></b-form-input></td>
                    <td><b-form-input type="text" v-model="crew.position" placeholder="name"></b-form-input></td>
                    <td><b-button v-if="formActivites.crews.length > 1" @click.prevent="removeCrewList(index)" size="sm" variant="danger" class="mb-3 mr-1"><i class="fa fa-trash"></i></b-button></td>
                </tr>
                </tbody>
                </table>
            </b-col>
            <b-col md="12">
                <b-button variant="warning" block class="mb-3 mr-1" @click.prevent="addCrewList()"><i class="fa fa-plus"></i> Add Crew</b-button>
            </b-col>
            </b-row>
        </b-col>
        <b-col md="6">
            <h5>Passenger List</h5>
            <b-row>
            <b-col md="12" v-if="formActivites.passengers.length > 0">
                <table class="table table-striped table-success">
                <thead>
                <tr>
                    <th width="15%">No</th>
                    <th width="40%">Name</th>
                    <th width="40%">Company</th>
                    <th width="5%">#</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(passenger, index) in formActivites.passengers" :key="index">
                    <td>{{index+1}}</td>
                    <td><b-form-input type="text" v-model="passenger.name" placeholder="name"></b-form-input></td>
                    <td><b-form-input type="text" v-model="passenger.company" placeholder="company"></b-form-input></td>
                    <td><b-button v-if="formActivites.passengers.length > 1" @click.prevent="removePassengerList(index)" size="sm" variant="danger" class="mb-3 mr-1"><i class="fa fa-trash"></i></b-button></td>
                </tr>
                </tbody>
                </table>
            </b-col>
            <b-col md="12">
                <b-button  variant="warning" block class="mb-3 mr-1" @click.prevent="addPassengerList()"><i class="fa fa-plus"></i> Add Passenger</b-button>
            </b-col>
            </b-row>
        </b-col>
        </b-row>
    </fieldset>
    </b-col>
    <b-col md="12" class="text-right">
        <b-button @click.prevent="saveVDR()" variant="primary" class="mr-2 text-right">Submit</b-button>
        <b-button @click.prevent="actionToParent()"  variant="none" class="iq-bg-danger text-right">Cancel</b-button>
    </b-col>
</b-row>
</template>

<script>
import { projectsActions, fleetsActions, portsActions, reasonsActions, vdrActions } from '@state/helpers';
import dayjs from 'dayjs'

export default {
    name: 'activitiesInput',
    data() {
        return {
            charteredOptions: [],
            fleetList : [],
            positionList : [],
            reasonList: [],
            windOptions: [
                { value: '1-5', text: '1-5' },
                { value: '6-10', text: '6-10' },
                { value: '11-15', text: '11-15' },
                { value: '16-20', text: '16-20' },
                { value: '21-25', text: '21-25' }
            ],
            crewListOptions: [
                {value: 'Capt. Jajang',text: 'Capt. Jajang', position: 'master'},
                {value: 'Rosia Hendi Hasworo',text: 'Rosia Hendi Hasworo', position: 'chief officer'},
                {value: 'Very Galih Saputro',text: 'Very Galih Saputro', position: '2nd officer'}
            ],
            formDailyActivitiesLoading: {
                _saving: false,
                dailyActivities: [
                {
                    startTime: '',
                    endTime: '',
                    operational: '',
                    remarks: '',
                },
                ]
            },
            formActivites : {
                date : '',
                lat : null,
                lon : null,
                portId : null,
                subProjectId : null,
                weathers: [
                    {
                        timeFrom: '00:00',
                        timeEnd: '',
                        wind: '',
                        visibility: '1',
                    },
                ],
                logs: [
                {
                    timeFrom: "00:00",
                    timeEnd: '',
                    reasonId: null,
                    remarks: ""
                }
                ],
                runningHours: [],
                robs: [],
                crews: [{
                    name: '',
                    position: '',
                }],
                passengers: [{
                    name: '',
                    company: ''
                }],
            },
            vehicleTypeIdSelected : null,
            fleetDetail: null
        }
    },
    props: {
        formData: {
            default: null,
            type: Object,
            required: false
        },
        isEdit: {
            default: false,
            type: Boolean,
            required: false
        },
    },
    mounted() {
        this.getProjectList();
        this.getFleetList();
        this.getPortList();
        this.getReasonList();
        if (this.isEdit === true) {
            this.initFormForEdit();
        }
    },
  methods: {
    ...projectsActions,
    ...fleetsActions,
    ...portsActions,
    ...reasonsActions,
    ...vdrActions,
    initFormForEdit() {
        this.vehicleTypeIdSelected = this.formData.vehicleId;
        this.getFleetDetail(this.formData.vehicleId)

        this.formActivites.date = this.formData.date;
        this.formActivites.lat = this.formData.lat || null;
        this.formActivites.lon = this.formData.lon || null;
        this.formActivites.portId = this.formData.port.id;
        this.formActivites.subProjectId = this.formData.subProject;

        if(this.formData.weathers && this.formData.weathers.length > 0) {
            this.formActivites.weathers = [];
            this.formData.weathers.forEach(el => {
            this.formActivites.weathers.push({
                    timeFrom: el.timeFrom,
                    timeEnd: el.timeEnd,
                    wind: el.wind,
                    visibility: el.visibility,
                });
            })
        }

        if(this.formData.logs && this.formData.logs.length > 0) {
            this.formActivites.logs = [];
            this.formData.logs.forEach(el => {
            this.formActivites.logs.push({
                    timeFrom: el.timeFrom,
                    timeEnd: el.timeEnd,
                    reasonId: el.reason.id,
                    remarks: el.remark,
                });
            })
        }

        if(this.formData.logs && this.formData.logs.length > 0) {
            this.formActivites.logs = [];
            this.formData.logs.forEach(el => {
            this.formActivites.logs.push({
                    timeFrom: el.timeFrom,
                    timeEnd: el.timeEnd,
                    reasonId: el.reason.id,
                    remarks: el.remark,
                });
            })
        }

        if(this.formData.crews && this.formData.crews.length > 0) {
            this.formActivites.crews = [];
            this.formData.crews.forEach(el => {
            this.formActivites.crews.push({
                    name: el.name,
                    position: el.position,
                });
            })
        }

        if(this.formData.passengers && this.formData.passengers.length > 0) {
            this.formActivites.passengers = [];
            this.formData.passengers.forEach(el => {
            this.formActivites.passengers.push({
                    name: el.name,
                    company: el.company,
                });
            })
        }   
           
    },
    async getProjectList() {
      let params = {
          active: true,
          search: ''
        }
        const res = await this.getProjects(params)
        if (res.status == 'success') {
          if(res.data && res.data.length > 0) {
            res.data.forEach(val => {
              this.charteredOptions.push({
                project: val.projectName,
                sub: val.subProject
              })
            })
          }
        } else {
          this.$swal(
            `Oops!`,
            res.data,
            'error'
          )
        }
    },
    async getFleetList() {
      let params = {
          vehicleTypeId: [],
          page: 1,
          active: true,
          showAll: true
        }
        const res = await this.getFleets(params)
        if (res.status == 'success') {
          this.fleetList = res.data
        } else {
          this.fleetList = {}
          this.$swal(
            `Oops!`,
            res.data,
            'error'
          )
        }
    },
    async getPortList() {
      let params = {
          active: true,
          search: ''
      }
        const res = await this.getPorts(params)
        if (res.status == 'success') {
         if(res.data && res.data.length > 0) {
            res.data.forEach(val => {
              this.positionList.push({ value: val.id, text: val.portName })
            })
         }
        } else {
          this.$swal(
            `Oops!`,
            res.data,
            'error'
          )
        }
    },
    async getReasonList() {
      let params = {
          search: ''
        }
        const res = await this.getReasons(params)
        if (res.status == 'success') {
         if(res.data && res.data.length > 0) {
            res.data.forEach(val => {
              this.reasonList.push({ value: val.id, text: val.name },)
            })
         }
        } else {
          this.$swal(
            `Oops!`,
            res.data,
            'error'
          )
        }
    },
    handleChangeSelectFleet(e) {
        if(e && e.target.value) {
            this.getFleetDetail(e.target.value)
        }
    },
    async getFleetDetail(id) {
        this.formActivites.runningHours = []
        this.formActivites.robs = []
        const res = await this.getFleetById(id)

      if (res.status == 'success') {
        this.fleetDetail = res.data;
        if (this.fleetDetail) {
            if (this.fleetDetail.powers && this.fleetDetail.powers.length > 0)
            this.fleetDetail.powers.forEach(el => {
                this.formActivites.runningHours.push({
                    powerId : el.id,
                    hoursRunningToday : null,
                    hoursRunningActual : el.actualRunningHours,
                })
            })
            if (this.fleetDetail.robs && this.fleetDetail.robs.length > 0) {
              this.fleetDetail.robs.forEach(el => {
                this.formActivites.robs.push({
                    robId: el.id,
                    openingRob: el.actualRob,
                    consumption: null,
                    transferred: null,
                    robActual: el.actualRob,
                    received: null,
                    remarks: ''
                })
            })
            }
        }
      } else {
        this.$swal(
          `Oops!`,
          res.data,
          'error'
        )
      }
    },
    addWeatherCondition () {
      this.formActivites.weathers.push(
          {
            timeFrom: this.formActivites.weathers.length !== 0 ? this.formActivites.weathers[this.formActivites.weathers.length-1].timeEnd :  '',
            timeEnd: '',
            wind: '',
            visibility: 1,
          }
      )
      this.formActivites.logs.push(
          {
            timeFrom: this.formActivites.weathers[this.formActivites.weathers.length-1].timeFrom,
            timeEnd: this.formActivites.weathers[this.formActivites.weathers.length-1].timeEnd,
            reasonId: null,
            remark: ""
          }
      )
    },
    removeWeatherCondition (index) {
      this.formActivites.weathers.splice(index, 1)
      this.formActivites.logs.splice(index, 1)
    },
    addActivitiesLoading () {
      this.formDailyActivitiesLoading.dailyActivities.push(
          {
            startTime: '',
            endTime: '',
            operational: '',
            remarks: '',
          }
      )
    },
    removeActivitiesLoading (index) {
      this.formDailyActivitiesLoading.dailyActivities.splice(index, 1)
    },
    addCrewList () {
      this.formActivites.crews.push(
          {
            name: '',
            position: '',
          }
      )
    },
    removeCrewList (index) {
      this.formActivites.crews.splice(index, 1)
    },
    addPassengerList () {
      this.formActivites.passengers.push(
          {
            name: '',
            company: '',
          }
      )
    },
    removePassengerList (index) {
      this.formActivites.passengers.splice(index, 1)
    },
    someHandler(e) {
        console.log(e)
    },
    actionToParent() {
      this.$emit("childAction", true);
    },
    totalCLosing(val1, val2, val3, val4) {
        return ((val1-val2-val3)+Number(val4?val4:0))
    },
    async saveVDR() {
        const payload = this.formActivites;
        payload.lat = payload.lat ? Number(payload.lat) : null;
        payload.lat = payload.lat ? Number(payload.lon) : null;
        payload.date =  dayjs(payload.date).format('DD-MM-YYYY');
        payload.subProjectId =  payload.subProjectId ? payload.subProjectId.id : null;
        payload.lat = payload.lat ? Number(payload.lon) : null;

        if (payload.weathers && payload.weathers.length > 0 ) {
            payload.weathers.forEach(el => {
                el.visibility = Number(el.visibility)
            })
        }

        if (payload.logs && payload.logs.length > 0 ) {
            payload.logs.forEach(el => {
                el.reasonId = el.reasonId ? Number(el.reasonId.value) : null
            })
        }

        if (payload.runningHours && payload.runningHours.length > 0 ) {
            payload.runningHours.forEach(el => {
                el.hoursRunningToday = el.hoursRunningToday ? Number(el.hoursRunningToday) : null
                el.hoursRunningActual = el.hoursRunningActual ? Number(el.hoursRunningActual) : null
            })
        }

        if (payload.robs && payload.robs.length > 0 ) {
            payload.robs.forEach(el => {
                el.consumption = el.consumption ? Number(el.consumption) : null
                el.transferred = el.transferred ? Number(el.transferred) : null
                el.received = el.received ? Number(el.received) : null
            })
        }
        console.log(payload, 'testt')
        let body = {
            payload : payload,
            vehicleId : this.vehicleTypeIdSelected,
        }
        
        if (this.isEdit) {
            body.id = this.formData.id;
            const res = await this.updateVDRbyVehicle(body)
            if (res.status == 'success') {
            this.$swal('Add VDR Success!', res.data.message, 'success')
            this.actionToParent();
            } else {
            this.$swal(
                `Oops!`,
                res.data.message,
                'error'
            )
            }
        } else {
            const res = await this.addVDR(body)
            if (res.status == 'success') {
            this.$swal('Add VDR Success!', res.data.message, 'success')
            this.actionToParent();
            } else {
            this.$swal(
                `Oops!`,
                res.data.message,
                'error'
            )
            }
        }
    }
  }
}
</script>